import type {
  ProductTrackingConfig,
  ParsedProductTrackingConfig,
} from '@analytics/models';

export const defaultCommerceMapperContext = {
  index: 0,
  listName: '',
  numberOfProducts: 1,
};

export function parseTrackProductConfig<TProduct, TCommerce>(
  config: ProductTrackingConfig<TProduct, TCommerce>
): ParsedProductTrackingConfig<TProduct, TCommerce> {
  return {
    mapToCommerce(input, context = defaultCommerceMapperContext) {
      return config.productToCommerce(input, context);
    },
  };
}
